$(function(){
    function handleChatWithSalesOnClick(){
        // Check if Kustomer chat widget is loaded and available
        if (window.Kustomer && typeof window.Kustomer.isChatAvailable === 'function') {
            try {
                var chatStatus = window.Kustomer.isChatAvailable();

                // Only open chat if it's online (available)
                if (chatStatus && chatStatus.availability === 'online') {
                    // Chat is available, open it
                    window.Kustomer.open();
                } else {
                    // Chat is not available (offline, disabled, hidden, or none), show custom popup
                    var $popup = $('.chat-with-sales-popup-pdp').first();
                    if ($popup.length > 0) {
                        Simplistic.openModal($popup, 'regular');
                    }
                }
            } catch (error) {
                // Error checking chat availability, fallback to custom popup
                console.log('Error checking Kustomer availability:', error);
                var $popup = $('.chat-with-sales-popup-pdp').first();
                if ($popup.length > 0) {
                    Simplistic.openModal($popup, 'regular');
                }
            }
        } else {
            // Kustomer not loaded, fallback to custom popup
            var $popup = $('.chat-with-sales-popup-pdp').first();
            if ($popup.length > 0) {
                Simplistic.openModal($popup, 'regular');
            }
        }

        return false;
    }
    
    $(document).off('click', '.chat-with-sales-button-pdp');
    $(document).on('click', '.chat-with-sales-button-pdp', handleChatWithSalesOnClick);
    
    // Handle form submission with multiple approaches to ensure it's caught
    function handlePDPFormSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        var form = $(e.target);
        var error = false;
        
        form.parent().find('.error-msg').hide();
        form.find('.error').removeClass('error');
    
        // Validate required fields
        form.find('.required').each(function(){
            if($(this).val().trim() == "") {
                error = true;
                $(this).addClass('error');
            }
        });
        
        if(error){
            form.parent().find('.error-msg').show().text('Please complete all the required fields.');
        } else {
            // Validate email
            var emailValue = form.find('input[name="contact[email]"]').val();
            if(!Simplistic.validateEmail(emailValue)) {
                error = true;
                form.find('input[name="contact[email]"]').addClass('error');
                form.parent().find('.error-msg').show().text('Please provide a valid email address.');
            }
        }
    
        if(!error) {
            var name = form.find('input[name="contact[name]"]').val() || '';
            var email = form.find('input[name="contact[email]"]').val() || '';
            var phone = form.find('input[name="contact[phone]"]').val() || '';
            var product = form.find('input[name="contact[product]"]').val() || '';
            var variant = form.find('input[name="contact[variant]"]').val() || '';
            var message = form.find('textarea[name="contact[message]"]').val() || '';

            // Submit to Klaviyo custom form using their AJAX endpoint
            var klaviyoFormData = {
                'g': 'TcW4fm', // Your list ID that the form is connected to
                '$fields': '$first_name,$last_name,$phone_number,contact_us_pdp_product_title,contact_us_pdp_product_details,contact_us_pdp_message,$source',
                'email': email,
                '$first_name': name.split(' ')[0] || '',
                '$last_name': name.split(' ').slice(1).join(' ') || '',
                '$phone_number': phone,
                'contact_us_pdp_product_title': product,
                'contact_us_pdp_product_details': variant,
                'contact_us_pdp_message': message,
                '$source': 'PDP Contact Form'
            };

            $.ajax({
                url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
                type: 'POST',
                data: klaviyoFormData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache'
                },
                success: function(response) {
                    // Form submitted successfully to Klaviyo
                    console.log('Klaviyo form submission successful:', response);
                    
                    // Also add them to back-in-stock notifications
                    var variantId;
                    // Check if we're in a quick-view modal
                    if ($('.tingle-modal .quick-view').length > 0) {
                        // In quick-view modal, get the addon variant ID
                        variantId = $('.tingle-modal .quick-view [name^=id]').val() || $('.tingle-modal .quick-view .select-variant').val();
                    } else {
                        // Regular PDP context
                        variantId = $('.add-to-cart-form [name^=id]').val();
                    }
                    if (variantId && email) {
                        addToBackInStock(email, variantId);
                    }
                    
                    // Show success message
                    form.parent().hide();
                    form.parent().parent().find('.success-msg').show();
                },
                error: function(xhr, status, error) {
                    if (xhr.status === 400) {
                        // 400 typically means email already exists - still show success
                        form.parent().hide();
                        form.parent().parent().find('.success-msg').show();
                        console.log('Email already exists in Klaviyo, but form data updated');
                    } else if (xhr.status === 302 || xhr.status === 0 || xhr.status === 200) {
                        // Redirect or CORS issues that still indicate success
                        form.parent().hide();
                        form.parent().parent().find('.success-msg').show();
                    } else {
                        // Actual error
                        form.parent().find('.error-msg').show().text('There was an error sending your message. Please try again or email us directly.');
                        console.error('Klaviyo form submission error:', xhr.status, status, error);
                    }
                }
            });
        }
    }
    
    // Multiple binding approaches to ensure our handler is called
    $(document).off('submit', '.chat-with-sales-popup-pdp form');
    $(document).on('submit', '.chat-with-sales-popup-pdp form', handlePDPFormSubmit);
    
    // Also bind directly when modal opens
    $(document).on('click', '.chat-with-sales-button-pdp', function() {
        setTimeout(function() {
            $('.chat-with-sales-popup-pdp form').off('submit').on('submit', handlePDPFormSubmit);
        }, 200);
    });
    
    // Also bind when tingle modal opens
    $(document).on('DOMNodeInserted', '.tingle-modal-box__content', function() {
        $('.chat-with-sales-popup-pdp form').off('submit').on('submit', handlePDPFormSubmit);
    });
    
    // Function to add contact to back-in-stock notifications
    function addToBackInStock(email, shopifyVariantId) {
        var klaviyoPublicKey = 'MBDndx';
        
        var backInStockPayload = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email
                            }
                        }
                    },
                    "channels": ["EMAIL"]
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": "$shopify:::$default:::" + shopifyVariantId
                        }
                    }
                }
            }
        };

        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + klaviyoPublicKey, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "revision": "2024-06-15"
            },
            body: JSON.stringify(backInStockPayload)
        })
        .then(function(response) {
            if (response.status === 202) {
                console.log('Successfully added to back-in-stock notifications');
            } else {
                console.log('Back-in-stock subscription response:', response.status);
            }
        })
        .catch(function(error) {
            console.log('Back-in-stock subscription error:', error);
        });
    }
    });


